import {
  Lemag,
  LeMagArticle,
  LeMagFeaturedArticle,
} from "@blacknut/javascript-sdk/dist";
import * as React from "react";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import { useTheme } from "../../theme/ThemeProvider";
import { QRCodeModal } from "../Modals/QRCodeModal";

export interface LeMagArticleModalProps extends ReactModal.Props {
  article: LeMagArticle | LeMagFeaturedArticle | Lemag;
  onClose: () => void;
}

const articleIsArticle = (
  art: LeMagArticle | LeMagFeaturedArticle | Lemag,
): art is LeMagArticle => {
  return "link" in art;
};

const LeMagArticleModal = ({
  isOpen,
  article,
  onClose,
}: React.PropsWithChildren<LeMagArticleModalProps>) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <QRCodeModal
      title={t("game.lemagmodal.titleArticle")}
      description={t("game.lemagmodal.qrCodeArticle")}
      btnText={t("notificationsPush.no")}
      URL={articleIsArticle(article) ? article.link : article.slug}
      theme={theme}
      onClose={onClose}
      isOpen={isOpen}
    />
  );
};

export default LeMagArticleModal;
